var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedTri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.124 21.4479C12.7825 21.6459 12.3947 21.7502 12 21.7502C11.6052 21.7502 11.2175 21.6459 10.876 21.4479C10.535 21.2502 10.2523 20.9661 10.0563 20.6243L10.0553 20.6225L1.80671 6.37501C1.60956 6.03355 1.50561 5.64628 1.50526 5.25199C1.50491 4.8577 1.60818 4.47024 1.80472 4.12844C2.00126 3.78663 2.28417 3.50247 2.62511 3.30442C2.96605 3.10637 3.35305 3.0014 3.74733 3.00001L3.74997 3.00001L20.25 3.00001L20.2526 3.00001C20.6469 3.0014 21.0339 3.10638 21.3748 3.30442C21.7158 3.50247 21.9987 3.78663 22.1952 4.12844C22.3918 4.47025 22.495 4.8577 22.4947 5.25199C22.4943 5.64628 22.3904 6.03355 22.1932 6.37501L13.9447 20.6225L13.9437 20.6243C13.7476 20.9661 13.4649 21.2502 13.124 21.4479Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTri);
export default __webpack_public_path__ + "static/media/red-tri.3668f40d57656369950b9dab32d7aa13.svg";
export { ForwardRef as ReactComponent };